<template>
  <div class="group-container">
    <transition name="fade" v-if="list.length">
      <TicketInline v-if="!hidden" :ticket="list[currentIndex][0]" :index="currentIndex" />
    </transition>
  </div>
</template>

<script>
import TicketInline from '../tickets/TicketInline';
import ContentCyclingMixin from "../../mixins/ContentCyclingMixin";

export default {
  name: 'GroupNoIssued',
  components: {TicketInline},
  mixins: [ContentCyclingMixin],
  props: {
    tickets: {type: Array, required: true}
  },
  data() {
    return {
    };
  },
};
</script>

<style lang="scss" scoped>
.group-container {
  width: 100%;
  height: 18.5155vh;
}

.fade-enter-active,
.fade-leave-active {
  transition: all 0.5s;
}
.fade-enter {
  opacity: 0;
  transform: translate(0, -20%);
}
.fade-leave-to {
  opacity: 0;
  transform: translate(0, 40%);
}
</style>
